// 3D Spline scene behind the home page hero.
// Set SPLINE_URL to the scene's public link (Spline: Export > Public URL, it looks like https://my.spline.design/...).
// Left empty, nothing is shown and the normal hero background stays. The scene loads after the page is
// ready, never on phones, slow connections or when the visitor asked for reduced motion, and never blocks clicks.
import { useEffect, useState } from "react";

export const SPLINE_URL = "https://my.spline.design/globaltransactions-wf3CP1Ba2PfhHJVgdnUsrYA5/";

export default function SplineBackground({ url = SPLINE_URL }) {
    const [show, setShow] = useState(false);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!url) return undefined;
        try {
            const wide = window.matchMedia("(min-width: 1024px)").matches;
            const calm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            const saver = navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType || ""));
            if (!wide || calm || saver) return undefined;
        } catch { return undefined; }
        const go = () => setShow(true);
        const t = window.requestIdleCallback ? window.requestIdleCallback(go, { timeout: 2500 }) : setTimeout(go, 1200);
        return () => { if (window.cancelIdleCallback && window.requestIdleCallback) window.cancelIdleCallback(t); else clearTimeout(t); };
    }, [url]);

    if (!url || !show) return null;
    return (
        <div aria-hidden="true" className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
            <iframe
                title="Decorative 3D background"
                src={url}
                loading="lazy"
                tabIndex={-1}
                onLoad={() => setReady(true)}
                className={`absolute inset-0 w-full h-full border-0 transition-opacity duration-1000 ${ready ? "opacity-100" : "opacity-0"}`}
            />
            {/* soft light wash so the headline and buttons always stay easy to read */}
            <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(253,251,247,0.92) 0%, rgba(253,251,247,0.65) 40%, rgba(253,251,247,0.1) 100%)" }} />
        </div>
    );
}
